import React from "react";
import { Card, CardHeader, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import Loading from 'layoutComponents/Loading';
import { isAlphaNumerical } from '../../utils/helper';
import EquipmentUtils from "../../utils/EquipmentUtils";


class DongleEquipment extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            serialNumber: '',
            isValid: false
        }

        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleValueChange(e) {
        e.preventDefault();
        const newSerialNumber = e.target.value;
        if (isAlphaNumerical(newSerialNumber) || newSerialNumber === "") {
            this.setState({
                serialNumber: newSerialNumber,
                isValid: newSerialNumber.length >= 16 && newSerialNumber.length <= 18
            });
        }
    }

    handleSubmit() {
        const { accountNumber, orderId, workOrderActions, itemNumber } = this.props;
        const { serialNumber } = this.state;
        
        const newSerialNumber = EquipmentUtils.getDongleEquipmentSerialNumber(serialNumber);

        workOrderActions.addEquipmentBySerialStarted({
            accountNumber: accountNumber, 
            serialNumber: newSerialNumber, 
            itemNumber: itemNumber},
            'dongleEquipmentAdd',
            orderId);
    }

    render() {
        const { title, loading, updateMessage } = this.props;
        const { serialNumber, isValid } = this.state;

        const reducedPaddingStyle = {
            paddingTop: '5px',
            paddingBottom: '5px'
        };

        const labelStyle = {
            fontSize: '11px',
            paddingLeft: '8px',
            paddingRight: '8px'
        };

        return <div>
            <Loading isLoading={loading} />
            <Card
                expanded={false}
                style={{
                    marginBottom: '8px'
                }}
            >
                <CardHeader
                    avatar={null}
                    style={reducedPaddingStyle}
                    actAsExpander={false}
                    title={title}
                    showExpandableButton={false}
                >
                    <RaisedButton
                        style={{float: 'right'}}
                        labelStyle={labelStyle}
                        disabled={!isValid}
                        label="Update"
                        onClick={this.handleSubmit}
                        key="updateDongleEquipment"
                    />
                </CardHeader>
                <CardText style={reducedPaddingStyle}>
                    {updateMessage}
                    <div>  
                        <input
                            className="browser-default"
                            value={serialNumber}
                            onChange={this.handleValueChange}
                            maxLength={18}
                        />
                    </div>
                </CardText>
            </Card>
        </div>
    }
}

export default DongleEquipment;


// WEBPACK FOOTER //
// ./src/components/equipment/DongleEquipment.js